<template>
  <BaseList listSubtitulo="Lista de logs" :data="dados.results" :columns="columns" :globalFilterFields="columns"
            :totalRecords="dados.count" @update:pagination="loadDataLazy" :btnFiltro="true" :btnPesquisar="false"
            @update:drawer="visibleRight = $event">

    <template #actions="{ data }">
      <div class="text-center">
        <button class="btn btn-outline-primary btn-sm font-bold"
                @click="abrirModal('informacoes', data.id, data.key)">
              <i class="fa fa-eye"></i> Visualizar
            </button>
      </div>
    </template>

  </BaseList>

  <Drawer
      v-model:visible="visibleRight"
      header="FILTRAR"
      position="right"
      :modal="true"
      :closeOnEscape="true"
      @show="onDrawerOpen"
  >
    <div class="text-center">
      <hr>
      <form id="id_form" @submit.prevent="submitFiltrarForm">
        <div class="form-group inline">
          <FloatLabel variant="on">
            <DatePicker
                id="data_inicio"
                v-model="dado.data_inicio"
                showIcon
                iconDisplay="input"
                size="small"
                style="width: 100%"
                appendTo="body"
                ref="dataInicio"
                dateFormat="dd/mm/yy"
            />
            <label for="data_inicio">
              <strong>Data Inicial: </strong>
            </label>
          </FloatLabel>
        </div>

        <div class="form-group inline">
          <FloatLabel variant="on">
            <DatePicker
                id="data_fim"
                v-model="dado.data_fim"
                showIcon
                iconDisplay="input"
                size="small"
                style="width: 100%"
                appendTo="body"
                ref="dataFim"
                dateFormat="dd/mm/yy"
            />
            <label for="data_fim">
              <strong>Data Final: </strong>
            </label>
          </FloatLabel>
        </div>

        <div class="form-group inline">
          <FloatLabel variant="on">
            <Select
                v-model="dado.modulo"
                inputId="modulo"
                :options="contentType"
                optionLabel="model"
                optionValue="id"
                size="small"
                appendTo="body"
                filter
                style="width: 100%"
            />
            <label for="modulo"><strong>Módulo: </strong></label>
          </FloatLabel>
        </div>

        <div class="form-group inline">
          <FloatLabel variant="on">
            <Select
                v-model="dado.usuario"
                inputId="usuario"
                :options="usuarios"
                optionLabel="username"
                optionValue="id"
                size="small"
                appendTo="body"
                filter
                style="width: 100%"
            />
            <label for="usuario"><strong>Usuário: </strong></label>
          </FloatLabel>
        </div>

        <div class="form-group inline">
          <FloatLabel variant="on">
            <Select
                v-model="dado.acao"
                inputId="acao"
                :options="acao"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
            />
            <label for="acao"><strong>Ação: </strong></label>
          </FloatLabel>
        </div>
        <br>
        <hr>
        <div class="text-center">
          <div class="float-right">
            <button type="button" class="btn btn-secondary" @click="limparFiltro">
              <i class="fa fa-eraser"></i> Limpar
            </button>
          </div>
          <div class="float-left">
            <button type="submit" class="btn btn-primary">
              <i class="fa fa-filter"></i> Filtrar
            </button>
          </div>
        </div>
      </form>
    </div>
  </Drawer>

  <InformacoesAuditoria
      v-if="modalAtivo === 'informacoes'"
      :idModal="'informacoesAuditoria'"
      @fechar="fecharModal"
      :itemSelect="itemSelect"
  />

</template>

<script>
import BaseList from "@/components/base/BaseList.vue";
import InformacoesAuditoria from "./InformacoesAuditoria.vue";
import {apiRequest, denormalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes"


export default {
  name: "ListaAuditoria",
  components: {
    BaseList,
    InformacoesAuditoria,
  },
  data() {
    return {
      dados: {
        results: [],
        count: 0,
      },
      pagination: {
        page: 1,
        page_size: 10,
      },
      usuarios: [],
      contentType: [],
      dado: {
        'data_inicio': null,
        'data_fim': null,
        'modulo': '',
        'usuario': null,
        'acao': null,
      },
      erro: null,
      visibleRight: false,
      modalAtivo: null,
      itemSelect: null,
      isStaff: localStorage.getItem('admin_isStaff'),
      columns: [
        {field: 'id', header: 'ID'},
        {field: 'modulo', header: 'MODULO'},
        {field: 'acao', header: 'AÇÃO'},
        {field: 'ator', header: 'USUÁRIO'},
      ],
      campoVazio: [],
      acao: [
        {label: 'Ação', value: '3'},
        {label: 'Atualizar', value: '1'},
        {label: 'Criar', value: '0'},
        {label: 'Deletar', value: '2'},
      ],
    };
  },
  methods: {
    onDrawerOpen() {
      if (this.$refs.dataInicio) {
        Inputmask("99/99/9999").mask(this.$refs.dataInicio.$el.querySelector("input"));
      }
      if (this.$refs.dataFim) {
        Inputmask("99/99/9999").mask(this.$refs.dataFim.$el.querySelector("input"));
      }
    },
    limparFiltro() {
      this.dado = {
        data_inicio: null,
        data_fim: null,
        modulo: '',
        usuario: null,
        acao: null,
      };
      this.loadDataLazy({page: 1, page_size: 10});
    },
    abrirModal(tipo, id = null,) {
      this.modalAtivo = tipo;
      if (id) {
        this.itemSelect = Number(id);
      }
    },
    fecharModal() {
      this.modalAtivo = null;
    },
    async loadDataLazy(paginationParams = this.pagination) {
      this.pagination = {
        page: paginationParams.page,
        page_size: paginationParams.page_size,
      };

      const payload = {...this.dado};

      for (const key in payload) {
        if (payload[key] === '' || payload[key] === null || payload[key] === undefined) {
          delete payload[key];
        }
      }

      const params = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
        ...payload
      };

      if (paginationParams.search) {
        params.search = paginationParams.search;
      }

      const resultado = await apiRequest("GET", apiUrl.auditoria.list, params);

      if (resultado.success) {
        this.dados.results = resultado.data.results || [];
        this.dados.count = resultado.data.count || 0;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      await this.loadDataLazy();
    },
    async getUsuarios() {
      const resultado = await apiRequest("GET", apiUrl.usuarios.createList);
      if (resultado.success) {
        this.usuarios = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getContentType() {
      const resultado = await apiRequest("GET", apiUrl.auditoria.contentTypeList);
      if (resultado.success) {
        this.contentType = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitFiltrarForm() {
      denormalizeDates(this.dado, ['data_inicio', 'data_fim']);
      const payload = {...this.dado};
      for (const key in payload) {
        if (payload[key] === '' || payload[key] === undefined) {
          payload[key] = null;
        }
      }
      const resultado = await apiRequest("POST", apiUrl.auditoria.list, this.dado);
      if (resultado.success) {
        this.dados.results = resultado.data.results || [];
        this.dados.count = resultado.data.count || 0;
        this.visibleRight = false;
        this.$toastMessage("success", "Filtro realizado com sucesso!");
      } else {
        this.campoVazio = Object.keys(resultado.error)
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
    this.getUsuarios();
    this.getContentType();
  },
};
</script>

<style scoped>
.form-group {
  max-width: 200px;
  width: 100%;
  margin-bottom: 1rem;
}
</style>
